import firebaseApp from '../../../../services/firebaseService';
import { BasicBaseHelper, IBasicBaseClass } from '../../base';

export interface IPumpingStationMotorMake extends IBasicBaseClass {
    name : string;

    isActive : boolean;
}

export default class PumpingStationMotorMakeHelper extends BasicBaseHelper {
    public static readonly COLLECTION_NAME = 'pumping_station_motor_make';

    private static converter : firebase.firestore.FirestoreDataConverter<IPumpingStationMotorMake> = {
        fromFirestore: (snapshot) => {
            return PumpingStationMotorMakeHelper.fromFirestoreDocument(snapshot);
        },
        toFirestore: (data : IPumpingStationMotorMake) : firebase.firestore.DocumentData => {
            return PumpingStationMotorMakeHelper.toFirestoreDocument(data);
        },
    };

    public static fromFirestoreDocument(snapshot : firebase.firestore.DocumentSnapshot) : IPumpingStationMotorMake {
        const result = super.fromFirestore(snapshot);
        const data = snapshot.data();

        if (!snapshot.exists || !result || !data) throw new Error(`Document does not exist! ${snapshot.id}`);
        return {
            ...data as IPumpingStationMotorMake,
            ...result,
        };
    }

    public static toFirestoreDocument(data : IPumpingStationMotorMake) {
        const result = super.toFirestore(data);
        const { id: _id, ...rest } = data;

        return {
            ...rest,
            ...result,
        };
    }

    public static doc(id ?: string) {
        if (!id) {
            return firebaseApp.firestore().collection(PumpingStationMotorMakeHelper.COLLECTION_NAME).withConverter(PumpingStationMotorMakeHelper.converter).doc();
        }

        return firebaseApp.firestore().collection(PumpingStationMotorMakeHelper.COLLECTION_NAME).withConverter(PumpingStationMotorMakeHelper.converter).doc(id);
    }

    public static save(company : IPumpingStationMotorMake) {
        return PumpingStationMotorMakeHelper.doc(company.id).set(company, {
            merge: true,
        });
    }
    
    public static collection() {
        return firebaseApp
            .firestore()
            .collection(PumpingStationMotorMakeHelper.COLLECTION_NAME)
            .withConverter(PumpingStationMotorMakeHelper.converter);
    }
}